import React, { SetStateAction } from 'react';

import CheckBoxGroup from '@components/Form/CheckBoxGroup';
import IconOpenTo from '@components/Images/Rebranding/IconOpenTo';
import { FilterOptionsResponse } from '@utils/backend-api/subscriber_directory';
import { FilterOption as FilterOptionType } from '@utils/backend-api/subscriber_directory';

import { ShowFilterMap } from './Content';
import FilterOption from './FilterOption';

interface FilterNavProps {
  handleResetForm: () => void;
  openToOptions: FilterOptionType[];
  setDisplayedFilterOptions: (option: SetStateAction<FilterOptionsResponse>) => void;
  setShowFilterMap: (showFilterMap: SetStateAction<ShowFilterMap>) => void;
  setShowSlideFilter: (showSlideFilter: boolean) => void;
  showFilterMap: ShowFilterMap;
  showSlideFilter: boolean;
}

const FilterNav = ({ openToOptions, setShowFilterMap, showFilterMap }: FilterNavProps) => {
  return (
    <div className="FilterNav">
      <FilterOption
        fieldName="openTo"
        icon={<IconOpenTo className="mr-8 w-16" />}
        input={<CheckBoxGroup name="openTo" options={openToOptions} />}
        label="Interested in"
        setShowFilterMap={setShowFilterMap}
        showFilter={showFilterMap['openTo']}
      />
    </div>
  );
};
export default FilterNav;
